export enum UserRole {
  Sales = 0,
  Admin = 1,
  NoPortalAccess = 2
}

export const UserRoleDisplay = {
  [UserRole.Admin]: 'Admin',
  [UserRole.Sales]: 'Limited',
  [UserRole.NoPortalAccess]: 'No Portal Access'
}
